import React, { useRef, useEffect, useState } from "react";
import '../css/components/Login.css'
import Logo from '../assets/logo3.png';
import ResponseMsg from '../general/ResponseMsg';
import { useNavigate } from "react-router-dom";

function HomePage() {
  const containerRef = useRef(null);

  const toggle = () => {
    const container = containerRef.current;
    if (container) {
      container.classList.toggle("sign-in");
      container.classList.toggle("sign-up");
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      const container = containerRef.current;
      if (container) {
        container.classList.add("sign-in");
      }
    }, 200);

    // Cleanup timeout
    return () => clearTimeout(timer);
  }, []);

const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
  const [showReset, setShowReset] = useState(false);
  const [response, setResponse] = useState(null);
    const [responseStatus, setResponseStatus] = useState();
  const [formData, setFormData] = useState({
    phone: '',
    password: ''
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value
    }));
  };

  const handleAdmin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch('https://api.kcmstore.in/store/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();
      setLoading(false);
      if (response.ok) {
        
        if (result[0].id == '1') {
          // console.log(result[0]);
          localStorage.setItem('userData', JSON.stringify(result));
          localStorage.setItem('isAdmin', 'true');
          setResponse('Login Successful.');
          setResponseStatus('success');
          setTimeout(() => {
            setResponse('');
            navigate('/dashboard');
            window.location.reload();
          }, 2000);
        }
         else {
          setResponse('Entered phone number not belongs to Admin!');
          setResponseStatus('error');
          setTimeout(() => {
            setResponse('');
          }, 2000)
        }
      }
      else if(response.status == 400){
        setResponse(result.message);
        setResponseStatus('error');
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleStaff = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('https://api.kcmstore.in/store/staff-login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();
      setLoading(false);
      if (response.ok) {
        localStorage.setItem('userData', JSON.stringify(result));
        localStorage.setItem('isStaff', 'true');
        setResponse('Login Successful.');
        setResponseStatus('success');
        setTimeout(() => {
          setResponse('');
          navigate('/branch-dashboard');
          window.location.reload();
        }, 2000)
      }
      else if(response.status == 400){
        setResponse(result.message);
        setResponseStatus('error');
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };


  const handleResetPassword = async (e) => {
    e.preventDefault();
    const { phone, password } = formData;

    try {
      const response = await fetch(`https://api.kcmstore.in/store/reset-admin-password/${phone}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password }),
      });

      const result = await response.json();
      if (response.ok) {
        setShowReset(false);
          setResponseStatus('success');
        setResponse(result.message);
        setTimeout(() => {
          setResponse('');
        }, 2000);
      } else {
          setResponseStatus('error');
        setResponse(result.message);
        setShowReset(false);
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      console.log(error);
    }
  };


  return (
    <>
    <div id="container" className="container-login" ref={containerRef}>
      <div className="row">

        <div className="col align-items-center flex-col sign-up">
        <div className="form-wrapper align-items-center">
            <div className="form sign-up">
            <img src={Logo} className='cursor-pointer' style={{height: '5em'}} onClick={()=> navigate('/')} alt="Logo" />
            <p className="tagline mt-0">KCM Online Store</p>

            {response && (
                                <p className={`fw-semibold my-3 rounded-2 fs-6 ${responseStatus === 'success' ? 'text-success' : 'text-danger'}`}>
                                    {responseStatus === 'success' ? <i className="fa-solid fa-circle-check"></i> : <i className="fa-solid fa-circle-xmark"></i>} {response}
                                </p>
                            )}

            {loading && (
            <div>
              <i class="fa-solid fa-spinner text-dark animate__animated animate__rotateIn animate__infinite fs-5 mt-3"></i>
            </div>
          )}

            <form className='mt-4' onSubmit={handleStaff}>
              <div className="input-group">
                <i className="bx bxs-business"></i>
                <input type="tel" value={formData.phone} id='phone' name="phone" maxLength='10' onChange={handleInputChange} placeholder="Mobile Number" />
              </div>
              <div className="input-group">
                <i className="bx bxs-lock-alt"></i>
                <input type="password" value={formData.password} id='password' name="password" onChange={handleInputChange} placeholder="Your Password" />
              </div>
                <button className="login-btn2">
                  Sign In
                </button>
              </form>
              <p className="fw-bold text-danger fs-6 cursor-pointer"  onClick={() => setShowReset(true)}>Forgot password?</p>
              <p>
                <span>Are you Admin? &nbsp;</span>
                <b onClick={toggle} className="pointer">
                  Sign in here
                </b>
              </p>
            </div>
          </div>
        </div>

        <div className="col align-items-center flex-col sign-in">
          <div className="form-wrapper align-items-center">
            <div className="form sign-in">
            <img src={Logo} className='cursor-pointer' style={{height: '5em'}} onClick={()=> navigate('/')} alt="Logo" />
            <p className="tagline mt-0">KCM Online Store</p>

            {response && (
                                <p className={`fw-semibold my-3 rounded-2 fs-6 ${responseStatus === 'success' ? 'text-success' : 'text-danger'}`}>
                                    {responseStatus === 'success' ? <i className="fa-solid fa-circle-check"></i> : <i className="fa-solid fa-circle-xmark"></i>} {response}
                                </p>
                            )}

            {loading && (
            <div>
              <i class="fa-solid fa-spinner text-dark animate__animated animate__rotateIn animate__infinite fs-5 mt-3"></i>
            </div>
          )}
                             <form onSubmit={handleAdmin}>

              <div className="input-group">
                <i className="bx bxs-user"></i>
                <input type="tel" value={formData.phone} name="phone" id="phone" maxLength='10' onChange={handleInputChange} placeholder="Mobile Number" />
              </div>
              <div className="input-group">
                <i className="bx bxs-lock-alt"></i>
                <input type="password" value={formData.password} name="password" id='password' onChange={handleInputChange} placeholder="Your Password" />
              </div>
              <button className="login-btn2">Sign in</button>
              </form>
              <p className="fw-bold text-danger fs-6 cursor-pointer"  onClick={() => setShowReset(true)}>Forgot password?</p>
              <p>
                <span>Are You Sub Admin? &nbsp;</span>
                <b onClick={toggle} className="pointer">
                  Sign in here
                </b>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="row content-row">
        <div className="col align-items-center flex-col">
          <div className="text sign-in">
            <h2>
              Welcome <br /> Admin
            </h2>
          </div>
          <div className="img sign-in"></div>
        </div>

        <div className="col align-items-center flex-col">
          <div className="text sign-up">
            <h2>
              Welcome <br /> Sub Admin
            </h2>
          </div>
        </div>

        
      </div>
    </div>


    {showReset && (
        <section className='delete-dialog px-3' onClick={() => setShowReset(false)}>
          <div className='bg-white col-lg-3 col-md-5 col-10 mx-auto px-3 py-3 rounded-4 animate__animated animate__zoomIn' onClick={(e) => e.stopPropagation()}>

            <p className='sec-heading fs-4'>Reset Password</p>


            <form className="row g-3 mt-4" onSubmit={handleResetPassword}>
              <div className="col-12 text-start">
                <input
                  type="tel"
                  className="form-input"
                  id="phone"
                  name="phone"
                  placeholder='Enter Mobile Number'
                  maxLength='10'
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="col-12 text-start">
                <input
                  type="password"
                  className="form-input"
                  id="password"
                  name="password"
                  placeholder='Enter New Password'
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="col-12 my-4">
                <button
                  className="danger-btn"
                  onClick={() => setShowReset(false)}
                >
                  Cancel
                </button>
                &nbsp;&nbsp;
                <button type="submit" className="success-btn">
                  Reset
                </button>
              </div>
            </form>
          </div>
        </section>
      )}


      {/* {response && <ResponseMsg message={response} />} */}

    </>
  );
}

export default HomePage;